module.exports = __webpack_public_path__ + "rightArrow___1pnh5.svg";